import { render, staticRenderFns } from "./updataSite.vue?vue&type=template&id=1cab1c14"
import script from "./updataSite.vue?vue&type=script&lang=js"
export * from "./updataSite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cab1c14')) {
      api.createRecord('1cab1c14', component.options)
    } else {
      api.reload('1cab1c14', component.options)
    }
    module.hot.accept("./updataSite.vue?vue&type=template&id=1cab1c14", function () {
      api.rerender('1cab1c14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compensationManagement/compensationList/components/updataSite.vue"
export default component.exports